import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CompnayPatientsService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdCompnayPatients(companyPatientId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'CompnayPatients/deleteCompnayPatients', {'companyPatientId': companyPatientId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countCompnayPatients(compnayPatients): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'CompnayPatients/count', {'compnayPatients': compnayPatients},
                                            this.httpOptions
        ).pipe(retry(3), catchError(Constant.handleError));
    }

    updateCompnayPatients(compnayPatients): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'CompnayPatients/updateCompnayPatients', [compnayPatients], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addCompnayPatients(compnayPatients): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'CompnayPatients/addCompnayPatients', [compnayPatients], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllCompnayPatients(compnayPatients, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'CompnayPatients/findAllCompnayPatients',
            {'compnayPatients': compnayPatients, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
